import React, {Component} from 'react';
import CustomStep from './customStep';
import {uiFlowBenAdmin} from "../../utils/common";
import {CustomGrid} from '../custom-common';

class Steps extends Component {
    render() {
        const {stepProps, uiFlow} = this.props;
        const stepsCount = stepProps.length;
        const steps = stepProps.map((s, idx) => {
            return <CustomGrid.Column key={idx} style={{padding: 0}}>
                <CustomStep completed={!!s.completed}
                            stepNumber={idx + 1}
                            active={!!s.active}
                            disabled={!!s.disabled}
                            numberLabel={s.numberLabel}
                            lastStep={stepsCount}/>
            </CustomGrid.Column>
        });

        const stepLabels = stepProps.map((s, idx) => {
            return <CustomGrid.Column key={idx}>
                <div style={{width: '130px', textAlign: 'center'}} className={(s.disabled) ? 'disabledStep' : ""}>
                    <p style={{whiteSpace: 'pre-line'}} className="smaller">{s.label}</p>
                </div>
            </CustomGrid.Column>
        });

        let stepsStyle = {marginLeft: '-210px', maxWidth: '450px', textAlign: 'center', marginBottom: '1em'};
        if(uiFlow === uiFlowBenAdmin && stepsCount === 3){
            stepsStyle = {marginLeft: '-165px', maxWidth: '350px', textAlign: 'center', marginBottom: '1em'};
        } else if(uiFlow === uiFlowBenAdmin && stepsCount === 2){
            stepsStyle = {marginLeft: '-120px', maxWidth: '260px', textAlign: 'center', marginBottom: '1em'};
        }

        return (
            <div className={'nonprintable'} style={{marginLeft: '50%', paddingTop: '8px'}}>
                <div className='steps' style={stepsStyle}>
                    <CustomGrid style={{marginLeft: '57px', marginRight: '0px'}} columns={steps.length}>
                        {steps}
                    </CustomGrid>
                    <CustomGrid style={{marginLeft: '0px', marginRight: '60px', marginTop: '0px'}} columns={steps.length}>
                        <CustomGrid.Row>
                            {stepLabels}
                        </CustomGrid.Row>
                    </CustomGrid>
                </div>
            </div>
        )
    }
}

export default Steps;